import { render, staticRenderFns } from "./ConfigurationsTexts.vue?vue&type=template&id=caf887ee"
import script from "./ConfigurationsTexts.vue?vue&type=script&lang=ts"
export * from "./ConfigurationsTexts.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports